<template>
  <PackageManager
    :is-open="isOpenWhatsapp"
    :channel-type-id="CHANNEL_TYPE.WHATSAPP"
    :translations="trans._packageManager.whatsapp"
    @close="close"
  />
</template>

<script setup lang="ts">
import PackageManager from "vue-app/components/PackageManager/PackageManager.vue";
import { usePackageManager } from "vue-app/composables/usePackageManager";
import { CHANNEL_TYPE } from "vue-app/types/enums";

const { isOpenWhatsapp, close } = usePackageManager();
</script>
